import { motion } from "framer-motion";
import Images from "../../utils/Images";

const PromotionalBanner = () => {
  return (
    <section className="overflow-hidden relative py-8 bg-gradient-to-r from-yellow-200 to-yellow-300 lg:py-12">
      <div className="px-4 mx-auto max-w-8xl sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6 justify-between items-center lg:gap-8 lg:flex-row">
          {/* Left Content - Text and CTA */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="z-10 flex-1 text-left"
          >
            <h2 className="mb-4 text-2xl font-bold text-gray-800 lg:mb-6 lg:text-4xl xl:text-5xl">
              Earn Commissions When You Promote{" "}
              <span className="text-white">Quality Products</span>
            </h2>

            <p className="mb-4 text-sm text-gray-700 lg:mb-6 lg:text-lg">
              Join our affiliate program and start earning by sharing amazing deals
            </p>
            
            <p className="text-sm text-gray-600 lg:text-base">
              Become a part of our growing community of affiliates and turn your influence into income
            </p>
          </motion.div>

          {/* Right Content - Product Showcase */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative flex-1 w-full max-w-2xl"
          >
            {/* White Panel with Shadow */}
            <div className="relative p-4 bg-white rounded-2xl shadow-xl lg:p-8 lg:rounded-3xl lg:shadow-2xl">
              {/* Product Images Container */}
              <div className="relative h-60 lg:h-80">
                {/* Shirt - Left Side */}
                <motion.div
                  initial={{ opacity: 0, rotate: -10 }}
                  animate={{ opacity: 1, rotate: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  className="absolute left-1 top-2 z-10 lg:left-2 lg:top-4"
                >
                  <img
                    src={Images.beatbox}
                    alt="Product Shirt"
                    className="object-contain w-32 h-40 lg:w-56 lg:h-72"
                  />
                </motion.div>

                {/* Phone - Top Right */}
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.6 }}
                  className="absolute top-2 right-8 z-20 lg:top-4 lg:right-48"
                >
                  <img
                    src={Images.phones}
                    alt="iPhone"
                    className="object-contain w-24 h-32 lg:w-44 lg:h-56"
                  />
                </motion.div>

                {/* Office Chair - Bottom Right */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.8 }}
                  className="absolute bottom-1 right-2 z-30 lg:bottom-2 lg:right-4"
                >
                  <img
                    src={Images.beatbox}
                    alt="Office Chair"
                    className="object-contain w-28 h-36 lg:w-48 lg:h-60"
                  />
                </motion.div>

                {/* Floating Elements */}
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 1.2 }}
                  className="absolute left-2 top-6 w-4 h-4 bg-yellow-400 rounded-full opacity-60 lg:left-4 lg:top-12 lg:w-6 lg:h-6"
                />
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 1.4 }}
                  className="absolute bottom-8 left-8 w-3 h-3 bg-orange-400 rounded-full opacity-60 lg:bottom-16 lg:left-16 lg:w-4 lg:h-4"
                />
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 1.6 }}
                  className="absolute right-8 top-12 w-3 h-3 bg-pink-400 rounded-full opacity-60 lg:right-16 lg:top-24 lg:w-5 lg:h-5"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalBanner;
